import { useMemo } from 'react';

import { CARE_ROLE } from '../../../../constants/props';
import {
  FAMILY_MEMBERS_OPTIONS,
  PARENT_OPTIONS,
} from '../../../../constants/strings';
import { convertRelationsList } from '../../../../utils/converters/convertListWithLocalization';

export default (value, formatMessage) => {
  const roleOptions = useMemo(() => {
    if (value === CARE_ROLE.PARENT) return PARENT_OPTIONS;
    return FAMILY_MEMBERS_OPTIONS;
  }, [value]);

  return convertRelationsList(roleOptions, formatMessage);
};



// WEBPACK FOOTER //
// ./src/components/common/FieldsList/utils/handleRelationshipOptions.js